




































import { Mixins, Component, Watch } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../../components/system";
import { EditableFormatSummary } from "../../../../../../domain/editableFormat";
import { FormatListViewer } from "../../../../viewers";

@Component({
  components: {
    FormatListViewer,
  }
})
export default class EditableFormatSummarySelectDialog extends Mixins(DialogMixin) {
  selectedFormat: EditableFormatSummary = null;
  selectedArchive: EditableFormatSummary = null;
  confirmSelected: boolean = false;

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  get isSelected(): boolean {
    return !!this.selectedFormat && !this.selectedFormat.deleted;
  }

  async show(): Promise<EditableFormatSummary> {
    return this.showModal(async () => {
      this.confirmSelected = false;
      await this.waitHidden();
      return this.confirmSelected ? this.selectedFormat.clone() : null;
    });
  }

  @Watch("selectedFormat")
  onSelectedFormatUpdated(newValue: EditableFormatSummary, oldValue: EditableFormatSummary): void {
    this.selectedArchive = newValue;
  }

  onFormatDoubleClicked(): void {
    if (this.isSelected) {
      this.confirmSelect();
    }
  }

  confirmSelect(): void {
    this.confirmSelected = true;
    this.isVisible = false;
  }

  cancelSelect(): void {
    this.isVisible = false;
  }
}
